import styled from '@emotion/styled';
import media from 'css-in-js-media';

export const MasonryDiv = styled.div`
  margin-top: 64px;
  padding: 0 16px;
  display: grid;
  grid-auto-flow: column;
  grid-gap: ${props => props.gap || `30px`};
  column-gap: 30px;

  .box {
    margin-bottom: 30px !important;
    max-width: 265px;
    p {
      margin-bottom: 0px !important;
    }
  }

  ${media('<tablet')} {
    width: auto;
    display: flex;
    flex-direction: column;
  }
`;
export const Col = styled.div`
  grid-gap: ${props => props.gap || `30px`};
`;
